import { render, staticRenderFns } from "./TaskContentList.vue?vue&type=template&id=a3a9c74e&scoped=true&"
import script from "./TaskContentList.vue?vue&type=script&lang=ts&"
export * from "./TaskContentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a9c74e",
  null
  
)

export default component.exports